module.exports = __webpack_public_path__ + "img/logo_p.65fb21cd.svg";